// extracted by mini-css-extract-plugin
module.exports = {"tagsContainer":"styles_tagsContainer__1IEMc","tag":"styles_tag__3-asJ","input":"styles_input__3Ukmm","hasTags":"styles_hasTags__tDY28"};